import { PaymentReceivedAmountSearchRule } from "./payment-received-amount-search-rule";
import { PaymentReceivedDateSearchRule } from "./payment-received-date-search-rule";
import { PaymentReceivedTextSearchRule } from "./payment-received-text-search-rule";

export class PaymentReceivedSearchRules {

    constructor(
        public dateSearch: PaymentReceivedDateSearchRule | null,
        public amountSearch: PaymentReceivedAmountSearchRule | null,
        public textSearch: PaymentReceivedTextSearchRule | null
    ){}
}
